import {useQuery} from "@tanstack/react-query";

import {ResponseError} from "@globals/types/utilityTypes";

import {fetchBrand} from "../BrandService";
import {Brand, BrandResource} from "../interfaces";

export default function useBrand(
  operatorSlug?: string,
  restaurantSlug?: string
): BrandResource {
  const isValidURL = Boolean(operatorSlug && restaurantSlug);
  const {data, isError, error, isFetching} = useQuery<Brand, ResponseError>({
    queryKey: ["brand", restaurantSlug, operatorSlug],
    queryFn: () => fetchBrand(operatorSlug!, restaurantSlug!),
    enabled: isValidURL,
  });

  return {
    brand: data,
    isFetching,
    isError: !isValidURL || isError,
    error: isValidURL ? error : {status: 404, message: ""},
  };
}
